import { AspectRatio, Box, Button, ButtonProps, Flex, Image } from '@chakra-ui/react';
import { TrashIcon } from '@sphere/icons';
import { rem } from 'polished';

interface Props {
  onClick: () => void;
  src: string;
}

export const ImageUploadThumbnail = ({ onClick, src, ...props }: Props & ButtonProps) => (
  <AspectRatio ratio={1 / 1} role="group">
    <Button onClick={onClick} p={0} variant="clear" {...props}>
      <Box boxSize="100%" p="space.4" border="1px solid" borderColor="gray.2" rounded="radius.8">
        <Image objectFit="cover" boxSize="100%" rounded="radius.8" src={src} />
        <Flex
          pos="absolute"
          inset="space.4"
          rounded="radius.8"
          bg="arcticBlue"
          align="center"
          justify="center"
          opacity={0}
          transition="opacity 160ms ease-in-out"
          _groupHover={{ opacity: 1 }}
        >
          <TrashIcon color="white" boxSize={rem(20)} />
        </Flex>
      </Box>
    </Button>
  </AspectRatio>
);
